import React, { useState } from 'react';
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Row,
  Button,
  Input,
  Spinner,
} from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import Select from 'react-select';
import TransactionTable from './TransactionTable';
import { useParams } from 'react-router-dom';
import TransactionSearch from './TransactionSearch';

const RewardTransactions = () => {
  const [search, setSearch] = useState('');
  const params = useParams();
  const options = [
    { value: 'ABCD', label: 'ABCD' },
    { value: 'EFGH', label: 'EFGH' },
    { value: 'IJKL', label: 'IJKL' },
    { value: 'MNOP', label: 'MNOP' },
    { value: 'QRST', label: 'QRST' },
    { value: 'UVWX', label: 'UVWX' },
  ];
  //
  document.title = 'Transactions History';
  return (
    <div className="page-content  p-4 pt-0">
      <BreadCrumb titleInActive={'Ahlan'} titleActive="Transaction History" />
      <Row>
        <Col md={12} className="m-auto">
          <div
            style={{ backdropFilter: ' blur(4px)' }}
            className="position-sticky top-0 z-1 d-flex justify-content-between align-items-center py-4"
          >
            <h4 className="mb-0">Ahlan Transactions</h4>
          </div>
        </Col>
      </Row>
      <TransactionSearch />
      <Row>
        <Col>
          <TransactionTable rewardTypeId={params?.path} />
        </Col>
      </Row>
    </div>
  );
};

export default RewardTransactions;
